import { SupermarketStaticNavPages } from "..\\..\\..\\..\\..\\src\\components\\SupermarketStaticNavPages";
import { MenuBuilderComponent } from '@tvlgiao/bc-supermarket-builder-components';
import React from 'react';
export default {
  SupermarketStaticNavPages,
  MenuBuilderComponent,
  React
};